module.exports = "/static/img/icon_chart_area.svg?bd24ffe414f36bbeff586e567a87414e";